import type { Profile } from '@entities/agent-contract';

import { phoneDisplayValueCasting } from '@shared/index';

import type { ProfileContactsData } from '../model';

export const getContacts = (profile?: Profile): ProfileContactsData => {
  const { email, phone, personalDocument } = profile || {};
  const { website } = personalDocument || {};

  return {
    phone: phone ? phoneDisplayValueCasting(phone) : undefined,
    email,
    website: {
      value: website,
      isLink: true,
    },
  };
};
